<template>
  <div :class="[`layout-${layoutStore.routeLayout}`, layoutStore.layoutClass?.layout]">
    <el-config-provider :locale="elLocale">
      <router-view
        :key="route.fullPath"
        :class="layoutStore.layoutClass?.header"
        name="header"
      />
      <router-view
        v-if="!layoutStore.iframeLink"
        :key="route.fullPath"
        v-bind="layoutStore.routeProps?.default"
      />
      <iframe
        v-if="layoutStore.iframeLink"
        id="hk-iframe"
        :key="route.fullPath"
        v-resize="myIframeResize"
        :class="fiatPageClass"
        :src="iframeFullLink"
        width="100%"
        frameborder="0"
        scrolling="no"
      />
      <router-view
        :key="route.fullPath"
        :class="layoutStore.layoutClass?.footer"
        name="footer"
        v-bind="layoutStore.routeProps?.footer"
      />
    </el-config-provider>
  </div>
  <!-- 待地址认证弹框 -->
  <!-- <AddressVerify v-if="userStore.isLogin && kycStatus" /> -->
  <!-- 提示弹窗 -->
  <WarningCfm
    v-if="userStore.activeOutStatus || userStore.loginStatusExpire"
    :visible="userStore.activeOutStatus || userStore.loginStatusExpire"
    :type="userStore.activeOutStatus ? 3 : 1"
    @up-visible="userStore.activeOutStatus ? userStore.changeOutStatus(false) : userStore.changeLoginStatus(false)"
  />
  <!-- 其他设备登录 -->
  <WarningCfmTwo
    :visible="userStore.loginOtherEquipment"
    :type="2"
    @up-visible="userStore.changeLoginOtherEquipment(false)"
  />
  <!-- vpn弹窗提示 -->
  <VpnWarning
    :visible="userStore?.vpnWarningInfo?.visible || false"
    :type="userStore?.vpnWarningInfo?.userLevel"
    :vpn-block-info="userStore?.vpnWarningInfo"
    @up-visible="userStore?.changeVpnWarningInfo({visible: false})"
  />
  <!-- 管辖区弹窗提示 (ip是美国，前不是app内打开的页面) -->
  <IpWarning
    v-if="commonStore?.isIpWarning && commonStore.isUs && !appStore?.jsbridgeStatus"
    :visible="commonStore?.isIpWarning && commonStore.isUs && !appStore?.jsbridgeStatus"
    @up-visible="commonStore?.changeIpWarning(false)"
  />
</template>
<script setup lang="ts">
import WarningCfm from '@c/common/WarningCfm.vue';
import WarningCfmTwo from '@c/common/WarningCfmTwo.vue';
import VpnWarning from '@c/common/VpnWarning.vue';
import IpWarning from '@c/common/IpWarning.vue';
import { getCurrentLocale } from '@/lang/element';
import { useLayoutStore } from '@/store/layout';
import { getOriginPath, i18n } from '@/lang/i18n';
import { useUserStore } from '@/store/User';
import { useAppStore } from '@/store/app';
import EventEmitter3 from 'eventemitter3';
// import iframeResize from 'iframe-resizer/js/iframeResizer';
import { toast } from '@/utils/toast';
import { ucApi } from '@/config/api';
import { useAssetsStore } from '@/store/assets';
import { useCommonStore } from '@/store/common';
import AddressVerify from './hk-components/AddressVerify.vue';
import { useKycInfoStore } from '@/store/kyc';
import CONST from '@/config/const';
import { apiHost } from '@/config/setup';
import { useSchemaOrg } from '@/hook/useSchemaOrg';
const { updateSchema } = useSchemaOrg();
const route = useRoute();
const layoutStore = useLayoutStore();
const userStore = useUserStore();
const assetStore = useAssetsStore();
const commonStore = useCommonStore();
const appStore = useAppStore();
const { locale } = useI18n();
const router = useRouter();
const eventEmitter = new EventEmitter3;
const kyc = useKycInfoStore();

// kyc状态判断
const kycStatus = computed(() => {
  if (kyc?.kycInfo?.totalAuditStatus == CONST.KycTotalStatusEnum.PASS) {
    // 已kyclAuditStat
    return true;
  } else {
    // 未kyc
    return false;
  }
});

// iframe lin
const iframeFullLink = computed(() => {
  if (location.port) {
    // 存在port，测试环境
    return  `${apiHost.webHKTest}${layoutStore.iframeLink}`;
  } else {
    return `${location.origin}${layoutStore.iframeLink}`;
  }
});
// 当前element对应语言的语言包
const elLocale = computed(() => getCurrentLocale(locale.value));

const fiatPageClass = computed(() => {
  // 判断当前iframe 是否为法币充值页面 需要设置高度
  let fiatRechargePage = layoutStore.iframeLink?.includes('fiatAccount/recharge');
  return fiatRechargePage ? 'fiatPage' : '';
});

// 初始化iframe的v-resize
const vResize = {
  mounted: (el: any, { value = {} }) => {
    el?.addEventListener('load', () => iframeResize(value, el));
  },
  unmounted: (el: any) => {
    el?.iFrameResizer?.removeListeners();
  }
};
// iframe配置和监听
const myIframeResize = ref({
  // log: true,
  inPageLinks: true, // 允许iframe调用parent的跳转
  checkOrigin: false,
  onMessage: (msg: any) => {
    if (msg.message['hidden-assets'] != undefined) {
      localStorage.setItem('hidden-assets', String(msg.message['hidden-assets']));
      assetStore.updateHiddenAssets(msg.message['hidden-assets']);
    }
    // pureexchange 登出
    if (msg?.message?.['logoutMsg']) {
      userStore.changeLoginStatus(true);
    }
    // pureexchange 其他设备导致登出
    if (msg?.message?.['logoutOtherEquipmentMsg']) {
      userStore.changeLoginOtherEquipment(true);
    }
    // pureexchange vpn弹窗提示
    if (msg?.message?.['vpnWarning']) {
      if (!userStore?.vpnWarningInfo?.visible) {
        ucApi.vpnBlocked({}).then((info: any) => {
          if (info.code == 200) {
            let userLevel = 1;
            if (msg?.message?.['vpnWarning'] == 200013) userLevel = 2;
            if (msg?.message?.['vpnWarning'] == 200014) userLevel = 3;
            // 6233 vpn提醒lv1弹窗出现undefined，预期：接口拿不到数据就不弹窗
            if ((userLevel == 1 && !info?.data?.vpnRemainDay) || (userLevel == 2 && !info?.data?.certId)) return;
            userStore.changeVpnWarningInfo({ ...info.data, visible: true, userLevel: userLevel });
          }
        });
      }
    }
    // emit sendmessage
    eventEmitter.emit('sendMessage', msg);
  },
  onResized: () => {
    document.querySelector('iframe#hk-iframe')?.iFrameResizer?.sendMessage({
      lang: i18n.global.locale.value,
      legal_flag: 'USD',
      parentOrigin: location.origin,
      parentLocation: window.location,
      hideAmount: localStorage.getItem('hidden-assets') == 'true'
    });
  }
});
// 触发emitter
eventEmitter.on('sendMessage', (msg: any) => {
  layoutStore.changeIframeMsg(msg);
});
// 监听 KycStatus
// watch(() => kyc?.kycInfo?.totalAuditStatus, (newValue: any) => {
//     const isZaFiatDeposit = route.path.includes("/custody/assetView/fiatAccount/deposit/regularTransfer"); // 是否是法币众安充值页面
//     // KYC未通过 需要拦截ZA充值页面
//     if (newValue != null && newValue != CONST.KycTotalStatusEnum.PASS && isZaFiatDeposit) {
//         router.push("/user/kyc");
//     }
// });
// 监听iframeLink
watch(() => layoutStore.iframeLink, (newValue: any) => {
  if (newValue) {
    // 存储当前信息
    localStorage.setItem('iframeInfo', JSON.stringify({
      lang: i18n.global.locale.value,
      legal_flag: 'USD',
      parentOrigin: location.origin,
      parentLocation: window.location
    }));
  } else {
    localStorage.removeItem('iframeInfo');
  }
}, { immediate: true });
// 监听layout iframeMsg
watch(() => layoutStore.iframeMsg as any, value => {
  // toast
  const toastInfo = value?.message?.toastInfo;
  if (toastInfo) {
    toast[`${Object.keys(toastInfo)[0]}`](`${Object.values(toastInfo)[0]}`);
  }
  // link
  if (value?.message?.type == 'link') {
    return router.push(value?.message?.url);
  }
});
// 监听路由, 更新schema
watch(() => route.path, (newValue: any) => {
  const path = getOriginPath(newValue);
  if (path) {
    // 通用类型：Organization（所有页面必加）, 页面层级：BreadcrumbList（所有路径层级页面添加）
    // 组织信息
    const organizationSchema = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      'name': 'HashKey Exchange',
      'logo': 'https://exchange.hashkey.com/favicon.ico',
      'url': 'https://exchange.hashkey.com',
      'sameAs': [
        'https://twitter.com/HashKeyExchange',
        'https://www.instagram.com/hellohashkey',
        'https://www.linkedin.com/company/hashkeyexchange/mycompany/',
        'https://t.me/hellohashkey'
      ]
    };
    // 面包屑导航
    const list = path.split('/').slice(1);
    const itemListElement = list.map((item: any, index: number) => {
      return {
        '@type': 'ListItem',
        'position': index + 1,
        'name': item || 'home',
        'item': `https://exchange.hashkey.com/${i18n.global.locale.value}/${list.slice(0, index + 1).join('/')}`
      };
    });
    const breadcrumbSchema = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      'itemListElement': itemListElement
    };
    // 更新schema
    updateSchema([organizationSchema, breadcrumbSchema]);
  }
}, { immediate: true });

// 监听用户登录状态，如果登录，则获取绑定通行密钥数量
watch(() => userStore.isLogin, isLogin => {
  if (isLogin && userStore.bindPasskeyCount === -1) {
    userStore.getBindPasskeyCount();
  }
}, { immediate: true });
</script>
<style lang="scss" scoped>
#hk-iframe {
  min-height: 800px;
}
</style>
